import { isLegacyServiceCircle } from './legacy_event';

describe('isLegacyServiceCircle', () => {
  it('company_id・sampling_company_idともに無ければfalse', () => {
    expect(
      isLegacyServiceCircle({ company_id: null, sampling_company_id: null }),
    ).toBe(false);
  });

  it('company_idがあればtrue', () => {
    expect(
      isLegacyServiceCircle({ company_id: 1, sampling_company_id: null }),
    ).toBe(true);
  });

  it('sampling_company_idがあればtrue', () => {
    expect(
      isLegacyServiceCircle({ company_id: null, sampling_company_id: 2 }),
    ).toBe(true);
  });

  it('circleが無ければfalse', () => {
    expect(isLegacyServiceCircle(null)).toBe(false);
    expect(isLegacyServiceCircle(undefined)).toBe(false);
  });
});
